// replan-stats-derive.ts — P5-2c aggregate MIT re-plan reasons for self-reflection.
// Each DailyPlan stores at most one `replanReason`; this counts them by label so
// the Journal can surface the top causes of broken plans. Pure + testable.
import type { DailyPlan } from "../types";

/** Preset reason labels offered when re-planning (structured → countable). */
export const REPLAN_REASONS = ["Việc đột xuất", "Ước lượng sai", "Sức khỏe", "Đổi ưu tiên"];

export type ReplanStat = { reason: string; count: number; pct: number };

/**
 * Count non-empty replan reasons across the given plans, newest-agnostic.
 * Returns entries sorted by count desc, each with its share (%) of the total.
 */
export function replanReasonStats(plans: Pick<DailyPlan, "replanReason">[]): {
  total: number;
  stats: ReplanStat[];
} {
  const counts = new Map<string, number>();
  for (const p of plans) {
    const reason = (p.replanReason ?? "").trim();
    if (!reason) continue;
    counts.set(reason, (counts.get(reason) ?? 0) + 1);
  }
  const total = [...counts.values()].reduce((a, b) => a + b, 0);
  const stats = [...counts.entries()]
    .map(([reason, count]) => ({ reason, count, pct: total ? Math.round((count / total) * 100) : 0 }))
    .sort((a, b) => b.count - a.count);
  return { total, stats };
}
